import React, { FC } from 'react'
import styles from 'styles/components/card.module.scss'
import { DayOfWeekType } from 'lib/daysOfWeek'
import equal from 'fast-deep-equal'
import { BusinessTimeType } from 'types/store'
import { Spacer } from 'components/Utility'
import { getBusinessTimeOnDay } from 'lib/businessHour'

type Props = {
  daysOfWeek: DayOfWeekType[]
  header: string
  businessTime: BusinessTimeType
}

const TimeColumn: FC<Props> = React.memo(
  (props) => {
    const { daysOfWeek, header, businessTime } = props
    return (
      <div className={styles.businessHour__column}>
        <h3 className={styles.businessHour__column__header}>{header}</h3>
        {daysOfWeek.map((dayOfWeek) => {
          const time = getBusinessTimeOnDay(dayOfWeek, businessTime)
          const className = time ? styles.businessHour__column__label : styles.businessHour__column__label_grey
          return (
            <React.Fragment key={dayOfWeek.toString()}>
              <Spacer size={12} />
              <div className={className}>{time ?? '定休日'}</div>
            </React.Fragment>
          )
        })}
      </div>
    )
  },
  (prev, next) => equal(prev, next)
)

export default TimeColumn
